import { ChangeEvent } from "react";

import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface IMedfarBillingSpecialtyPopupProps {
    patientId: string;
    onCloseCallback: () => void;
}

class MedfarBillingSpecialtyPopupState {
    public selectedSpeciality: number;

    constructor(s: MedfarBillingSpecialtyPopupState = null) {
        if (s != null) {
            this.selectedSpeciality = s.selectedSpeciality;
        }
        else {
            this.selectedSpeciality = 0;
        }
    }
}

class MedfarBillingSpecialtyPopup extends BaseReactComponent<IMedfarBillingSpecialtyPopupProps, MedfarBillingSpecialtyPopupState> {
    public render(): JSX.Element {
        let specialityDictionnaries: { [id: number]: string } = {};
        // Data initialization for specialities dictionnaries
        {
            specialityDictionnaries[0] = "Médecine de famille";
            specialityDictionnaries[1] = "Allergie et immunologie clinique";
            specialityDictionnaries[2] = "Anatomo-pathologie";
            specialityDictionnaries[3] = "Anesthésie-réanimation";
            specialityDictionnaries[4] = "Microbiologie médicale et infectiologie";
            specialityDictionnaries[5] = "Biochimie médicale";
            specialityDictionnaries[6] = "Cardiologie";
            specialityDictionnaries[7] = "Chirurgie générale";
            specialityDictionnaries[8] = "Chirurgie orthopédique";
            specialityDictionnaries[9] = "Chirurgie plastique";
            specialityDictionnaries[10] = "Chirurgie thoracique";
            specialityDictionnaries[11] = "Dermatologie";
            specialityDictionnaries[12] = "Gastro-entérologie";
            specialityDictionnaries[13] = "Gynécologie";
            specialityDictionnaries[14] = "Obstétrique-gynécologie";
            specialityDictionnaries[15] = "Hématologie";
            specialityDictionnaries[16] = "Hygiène et santé publique";
            specialityDictionnaries[17] = "Pneumologie";
            specialityDictionnaries[18] = "Médecine interne";
            specialityDictionnaries[19] = "Physiatrie";
            specialityDictionnaries[20] = "Neurochirurgie";
            specialityDictionnaries[21] = "Neuropsychiatrie";
            specialityDictionnaries[22] = "Neurologie";
            specialityDictionnaries[23] = "Obstétrique";
            specialityDictionnaries[24] = "Ophtalmologie";
            specialityDictionnaries[25] = "Oto-rhino-laryngologie";
            specialityDictionnaries[26] = "Pathologie clinique";
            specialityDictionnaries[27] = "Pédiatrie";
            specialityDictionnaries[28] = "Psychiatrie";
            specialityDictionnaries[29] = "Radiologie diagnostique";
            specialityDictionnaries[30] = "Radio-oncologie";
            specialityDictionnaries[31] = "Urologie";
            specialityDictionnaries[32] = "Chirurgie cardio-vasculaire et thoracique";
            specialityDictionnaries[33] = "Médecine nucléaire";
            specialityDictionnaries[34] = "Néphrologie";
            specialityDictionnaries[35] = "Endocrinologie";
            specialityDictionnaries[36] = "Rhumatologie";
            specialityDictionnaries[37] = "Électroencéphalographie";
            specialityDictionnaries[38] = "Santé communautaire";
            specialityDictionnaries[39] = "Médecine familiale";
            specialityDictionnaries[40] = "Ultrasonographie";
            specialityDictionnaries[41] = "Internat rotatoire";
            specialityDictionnaries[42] = "Internat mixte ou multidisciplinaire";
            specialityDictionnaries[43] = "Neuro-ophtalmologie";
            specialityDictionnaries[44] = "Néo-natologie";
            specialityDictionnaries[45] = "Gériatrie";
            specialityDictionnaries[46] = "Oncologie médicale";
            specialityDictionnaries[48] = "Génétique médicale";
            specialityDictionnaries[49] = "Médecine d'urgence";
            specialityDictionnaries[51] = "Gériatrie";
            specialityDictionnaries[55] = "Chirurgie vasculaire";
            specialityDictionnaries[60] = "Chirurgie buccale";
            specialityDictionnaries[61] = "Orthodontie";
            specialityDictionnaries[62] = "Périodontie";
            specialityDictionnaries[63] = "Prosthodontie";
            specialityDictionnaries[64] = "Hygiène dentaire publique";
            specialityDictionnaries[65] = "Endodontie";
            specialityDictionnaries[66] = "Pédodontie";
            specialityDictionnaries[67] = "Médecine buccale";
            specialityDictionnaries[82] = "Rémunération différenciée";
            specialityDictionnaries[90] = "Électromyographie";
            specialityDictionnaries[99] = "Optométrie";
        }

        return (
            <div className="fmp-speciality">
                <div className="header">
                    <h4>{cacheStore.GetString("SpecialityLabel")}</h4>
                </div>

                <div className="main">
                    <div className="row">
                        <div className="col-sm-2 col-md-2 col-lg-2 text-right">
                            <label className="label-input">{cacheStore.GetString("TypeLabel")}</label>
                        </div>
                        <div className="col-sm-10 col-md-10 col-lg-10" style={{ paddingRight: "25px" }}>
                            <select className="form-control myle-control minimal" onChange={this.onSpecialityChange.bind(this)}>
                                {Object.keys(specialityDictionnaries).map(x => (
                                    <option key={x} value={x}>{specialityDictionnaries[x]}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="footer">
                    <div className="text-right">
                        <button className="btn btn-default push-right-5" onClick={() => this.props.onCloseCallback()}>{cacheStore.GetString("CloseLabel")}</button>
                        <button className="btn btn-primary" onClick={() => this.onSaveClickAsync()}>{cacheStore.GetString("SaveLabel")}</button>
                    </div>
                </div>
            </div>
        );
    }

    public componentWillMount(): void {
        var s = new MedfarBillingSpecialtyPopupState();
        this.setState(s);
    }

    private async onSaveClickAsync(): Promise<void> {
        const response = await Client.postAsync<{ SpecialtyCode: number, IsSuccess: boolean }>(
            ServerOperations.Server.MedfarBilling_SaveSpecialty,
            {
                SpecialityCode: this.state.selectedSpeciality,
                LicenceNumber: sessionStore.getCurrentEmployee().Model.Licences[0].LicenceNumber
            }
        );

        if (!response.data.IsSuccess)
            return;

        patientStore.PatientMedicalNoteModels[this.props.patientId] = patientStore.PatientMedicalNoteModels[this.props.patientId]
            .set("SpecialtyMedfarBillingPopup", false)
            .set("IsMedfarBillingSpecialist", response.data.SpecialtyCode !== 0);

        sessionStore.hideGlobalOverlay();

        window.setTimeout(
            () => sessionStore.dispatch(LocalPatientOperations.MedfarBilling.PrepareNewBill),
            50
        );
    }

    private onSpecialityChange(e: ChangeEvent<HTMLSelectElement>): void {
        const selectedSpeciality = e.target.value;

        this.mutateState(s => s.selectedSpeciality = Number(selectedSpeciality));
    }
}

export { MedfarBillingSpecialtyPopup };
